import Debug from '@/util/debug';

const debug = Debug('gender-selector');

export default {
  props: {
    selected: {
      validator: value => Array.isArray(value) && value.length <= 2,
    },
  },
  methods: {
    toggle(gender) {
      const index = this.selected.indexOf(gender);

      // Do not mutate this.seected in this function
      // Instead emit event with the new value

      if (index >= 0) {
        if (this.selected.length > 1) {
          const newSelection = [
            ...this.selected.slice(0, index),
            ...this.selected.slice(index + 1),
          ];

          debug.info('selected %j', newSelection);
          this.$emit('update:selected', newSelection);
        }
      } else {
        const newSelection = [...this.selected, gender];
        debug.info('selected %j', newSelection);
        this.$emit('update:selected', newSelection);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/gender-selector/GenderSelector.js